module.exports = __webpack_public_path__ + "static/media/mgm_hero.850e86c3.jpg";